function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDropdownIcon = function SvgDropdownIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M.398 3.75c-.359.336-.46.8-.285 1.238.086.188 1.774 1.961 3.75 3.926L7.45 12.5h1.102l3.586-3.586c1.976-1.965 3.664-3.738 3.75-3.926.3-.75-.211-1.488-1.063-1.488-.472 0-.586.086-3.66 3.148L8 9.801 4.836 6.648C1.762 3.586 1.648 3.5 1.176 3.5q-.512.002-.778.25m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000",
      fillOpacity: 1
    }
  }));
};
export default SvgDropdownIcon;